import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import propTypes from 'prop-types';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Autocomplete from '@mui/material/Autocomplete';
import { StyledButton } from '../../../Components/Generics.styled';

const NavigationSection = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 160px;
    margin-left: auto;
    margin-right: auto;
`;

const StyledTextField = styled(TextField)`
    /* width: 350px; */
`;

const StyledDropdown = styled.div`
    width: 400px;
`;

const ModalContainer = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
`;

const RadioSection = styled.div`
    .MuiFormGroup-root {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
`;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 800,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const inputTypeArray = ['Text', 'Dropdown', 'Radio', 'Slider', 'Address'];
const responseFormatItems = ['Free Text', 'Dollars', 'Cents', 'Kilowatts'];

const AddNewQuestionModal = (props) => {
    const {
        modalIsOpen,
        setModalIsOpen,
        questionData,
        setQuestionData,
        resetFields,
        addDataToRows,
    } = props;
    const [itemsVal, setItemsVal] = useState([]);

    const handleItems = (e) => {
        setItemsVal([e.target.value]);
    };
    const { questionText, placeholder, isRequired, inputType, responseFormat, inputOptions } = {
        ...questionData,
    };

    const handleClose = () => {
        resetFields();
        setModalIsOpen(false);
    };

    const handleInputTypeChange = (e) => {
        setQuestionData({
            ...questionData,
            inputType: e.target.value,
        });
    };

    const handleResponseFormatChange = (e) => {
        setQuestionData({
            ...questionData,
            responseFormat: e.target.value,
        });
    };

    const calculateIsRequiredVal = () => {
        if (isRequired === true) {
            return 'Yes';
        }
        if (isRequired === false) {
            return 'No';
        }
    };

    const doneButtonIsDisabled =
        questionText === '' ||
        placeholder === '' ||
        inputType === '' ||
        ((inputType === 'Text' || inputType === 'Slider') && responseFormat === '') ||
        ((inputType === 'Slider' || inputType === 'Dropdown' || inputType === 'Radio') &&
            inputOptions.length < 2) ||
        (inputType === 'Slider' &&
            (inputOptions.indexOf('') > -1 || inputOptions.indexOf(undefined) > -1));

    const isANumberRegex = /^[0-9]*$/;

    const body = (
        <div style={style}>
            <ModalContainer>
                <Title>Add a New Question</Title>
                <br />
                <StyledTextField
                    id="question-text"
                    label="Question"
                    placeholder="Enter your question here"
                    defaultValue={questionText}
                    onChange={(e) =>
                        setQuestionData({
                            ...questionData,
                            questionText: e.target.value,
                        })
                    }
                    variant="outlined"
                    required
                    error={questionText === ''}
                />
                <br />
                <StyledTextField
                    id="question-placeholder"
                    label="Placeholder Text"
                    placeholder="Enter your placeholder text here"
                    defaultValue={placeholder}
                    onChange={(e) =>
                        setQuestionData({
                            ...questionData,
                            placeholder: e.target.value,
                        })
                    }
                    variant="outlined"
                    required
                    error={placeholder === ''}
                />
                <br />

                <div
                    style={{
                        width: '400px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <div>Is this a required question?</div>
                    <RadioSection>
                        <FormControl component="fieldset">
                            <RadioGroup
                                aria-label="isRequired"
                                name="isRequired"
                                value={calculateIsRequiredVal()}
                                onChange={(e) =>
                                    setQuestionData({
                                        ...questionData,
                                        isRequired: e.target.value === 'Yes',
                                    })
                                }
                            >
                                <FormControlLabel
                                    value="Yes"
                                    control={
                                        <Radio
                                            style={{ color: isRequired === '' ? 'red' : '#3F51B5' }}
                                        />
                                    }
                                    label="Yes"
                                />
                                <FormControlLabel
                                    value="No"
                                    control={
                                        <Radio
                                            style={{ color: isRequired === '' ? 'red' : '#3F51B5' }}
                                        />
                                    }
                                    label="No"
                                />
                            </RadioGroup>
                        </FormControl>
                    </RadioSection>

                    <br />
                    <StyledDropdown>
                        <FormControl fullWidth required error={inputType === ''} variant="outlined">
                            <InputLabel variant="outlined" id="input-type">
                                What is this input type?
                            </InputLabel>
                            <Select
                                labelId="input-type"
                                id="input-type"
                                value={inputType}
                                onChange={(e) => handleInputTypeChange(e)}
                                label="Input Type"
                            >
                                {inputTypeArray.map((item, idx) => (
                                    <MenuItem key={idx} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </StyledDropdown>
                    <br />
                    {inputType === 'Text' || inputType === 'Slider' ? (
                        <div>
                            <StyledDropdown>
                                <FormControl
                                    required
                                    error={responseFormat === ''}
                                    fullWidth
                                    variant="outlined"
                                >
                                    <InputLabel variant="outlined" id="response-format">
                                        What is the response format?
                                    </InputLabel>
                                    <Select
                                        labelId="response-format"
                                        id="response-format"
                                        value={responseFormat}
                                        onChange={(e) => handleResponseFormatChange(e)}
                                        label="Response Format"
                                    >
                                        {responseFormatItems.map((item, idx) => (
                                            <MenuItem key={idx} value={item}>
                                                {item}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </StyledDropdown>
                            <br />
                        </div>
                    ) : null}

                    {inputType === 'Slider' ? (
                        <div>
                            <TextField
                                value={questionData.inputOptions[0]}
                                variant="outlined"
                                placeholder="Min"
                                helperText={
                                    questionData.inputOptions[0] === '' ||
                                    questionData.inputOptions[0] === undefined
                                        ? 'Min value must be a number.'
                                        : ''
                                }
                                error={
                                    questionData.inputOptions[0] === '' ||
                                    questionData.inputOptions[0] === undefined
                                }
                                style={{ width: 150, marginRight: 50 }}
                                onChange={(e) =>
                                    setQuestionData({
                                        ...questionData,
                                        inputOptions: e.target.value.match(isANumberRegex)
                                            ? [e.target.value, inputOptions[1]]
                                            : ['', inputOptions[1]],
                                    })
                                }
                            />
                            <TextField
                                value={questionData.inputOptions[1]}
                                variant="outlined"
                                placeholder="Max"
                                style={{ width: 150 }}
                                helperText={
                                    questionData.inputOptions[1] === '' ||
                                    questionData.inputOptions[1] === undefined
                                        ? 'Max value must be a number.'
                                        : ''
                                }
                                error={
                                    questionData.inputOptions[1] === '' ||
                                    questionData.inputOptions[1] === undefined
                                }
                                onChange={(e) =>
                                    setQuestionData({
                                        ...questionData,
                                        inputOptions: e.target.value.match(isANumberRegex)
                                            ? [inputOptions[0], e.target.value]
                                            : [inputOptions[0], ''],
                                    })
                                }
                            />
                        </div>
                    ) : null}

                    {inputType === 'Dropdown' || inputType === 'Radio' ? (
                        <Autocomplete
                            multiple
                            id="items"
                            sx={{ width: 400 }}
                            options={itemsVal}
                            value={inputOptions || ['']}
                            getOptionLabel={(option) => option}
                            onChange={(e, value) =>
                                setQuestionData({ ...questionData, inputOptions: value })
                            }
                            renderInput={(params) => (
                                <TextField
                                    onChange={(e) => handleItems(e)}
                                    variant="outlined"
                                    {...params}
                                    label="Items"
                                    placeholder="Items"
                                    error={inputOptions.length < 2}
                                    helperText={
                                        inputOptions.length < 2
                                            ? 'Please enter 2 or more choices for users to select from.'
                                            : ''
                                    }
                                />
                            )}
                        />
                    ) : null}
                    <NavigationSection>
                        <StyledButton
                            onClick={() => setCancelConfirmModal(true)}
                            variant="contained"
                            color="primary"
                        >
                            Cancel
                        </StyledButton>
                        <StyledButton
                            disabled={doneButtonIsDisabled}
                            onClick={() => addDataToRows()}
                            variant="contained"
                            color="primary"
                        >
                            Done
                        </StyledButton>
                    </NavigationSection>
                </div>
            </ModalContainer>
        </div>
    );

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

AddNewQuestionModal.propTypes = {
    modalIsOpen: propTypes.bool,
    setModalIsOpen: propTypes.func,
    questionData: propTypes.shape({
        question: propTypes.string,
        placeholder: propTypes.string,
        isActive: propTypes.string,
        isRequired: propTypes.bool,
        questionFormat: propTypes.string,
        inputType: propTypes.string,
        items: propTypes.array,
        inputOptions: propTypes.array,
    }),
    setQuestionData: propTypes.func,
    resetFields: propTypes.func,
    addDataToRows: propTypes.func,
};

AddNewQuestionModal.defaultProps = {
    modalIsOpen: false,
    setModalIsOpen: () => {},
};
export default AddNewQuestionModal;
